import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { usePreferredPMSVersion } from '~/composables/usePreferredPMSVersion'

const handleUseNewVersionQueryParam = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const useNewVersion = to.query.use_new_version

  if (useNewVersion === 'true') {
    usePreferredPMSVersion().useNew()
  }

  return next()
}

export default handleUseNewVersionQueryParam
